import { render } from "./App.vue?vue&type=template&id=46c1e656"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=46c1e656&lang=css"

import exportComponent from "/Users/oat/WebstormProjects/media_service_test/player/livestream-player/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.72.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__